/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
import { X } from "lucide-react";

const LogoutModal = ({ isOpen, onClose, onConfirm, isDarkMode }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      {/* Modal Container */}
      <div
        className={`relative rounded-3xl p-8 w-full max-w-md shadow-2xl animate-in fade-in zoom-in duration-300 ${
          isDarkMode ? "bg-dark-surface" : "bg-white"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className={`absolute top-6 right-6 p-2.5 rounded-full transition-all ${
            isDarkMode
              ? "hover:bg-dark-background text-dark-text"
              : "hover:bg-gray-100 text-gray-700"
          }`}
          aria-label="Close modal"
        >
          <X size={26} />
        </button>

        {/* Modal Content */}
        <div className="text-center">
          {/* Warning Icon */}
          <div className="mb-6">
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto ${
                isDarkMode ? "bg-red-500/20" : "bg-red-100"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-8 w-8 ${
                  isDarkMode ? "text-red-400" : "text-red-500"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h2
            className={`text-2xl font-bold mb-3 ${
              isDarkMode ? "text-dark-text" : "text-gray-900"
            }`}
          >
            Confirm Logout
          </h2>

          {/* Description */}
          <p
            className={`mb-8 text-base ${
              isDarkMode ? "text-dark-muted" : "text-gray-600"
            }`}
          >
            Are you sure you want to end your current session? You&apos;ll need
            to log in again to access your account.
          </p>

          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className={`flex-1 py-3 rounded-xl font-semibold transition-all ${
                isDarkMode
                  ? "bg-dark-background hover:bg-dark-border text-dark-text"
                  : "bg-gray-100 hover:bg-gray-200 text-gray-700"
              }`}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 py-3 rounded-xl font-semibold transition-all ${
                isDarkMode
                  ? "bg-red-500 hover:bg-red-600 text-dark-text"
                  : "bg-red-500 hover:bg-red-600 text-white"
              }`}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
